import { render } from "./Collaborations.vue?vue&type=template&id=505cac84&scoped=true"
const script = {}

import "./Collaborations.vue?vue&type=style&index=0&id=505cac84&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505cac84"]])

export default __exports__